<script setup>
  const props = defineProps({
    class: {
      type: String,
      default: ''
    }
  });
</script>

<template>
  <div class="flex flex-row items-center gap-2 !text-inherit" :class="class">
    <img
      src="/images/spicy-collab-icon.png"
      class="h-8 w-8 shrink-0 object-contain"
      alt="Spicy Collab"
    />
    <span class="whitespace-nowrap text-lg font-bold text-current">Spicy Collab</span>
  </div>
</template>
